/**
 * Attributes a request to the UI in the backend's request log, which reads it into
 * `details.source_type`. Split out from the interceptor so the raw-fetch transports — which never
 * reach the HttpClient chain and have to send this themselves — do not have to pull in an
 * HttpInterceptor to get at the name.
 */
export const SOURCE_TYPE_HEADER_NAME = "X-Source-Type";
export const SOURCE_TYPE_UI          = "UI";
